var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1242_16044)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3597 16.2655L22.1097 20.0155C22.1801 20.0859 22.2755 20.1254 22.375 20.1254C22.4745 20.1254 22.57 20.0859 22.6403 20.0155C22.7107 19.9452 22.7502 19.8497 22.7502 19.7502C22.7502 19.6507 22.7107 19.5553 22.6403 19.4849L19.1552 16.0002L22.6403 12.5155C22.7107 12.4452 22.7502 12.3497 22.7502 12.2502C22.7502 12.1507 22.7107 12.0553 22.6403 11.9849C22.57 11.9145 22.4745 11.875 22.375 11.875C22.2755 11.875 22.1801 11.9145 22.1097 11.9849L18.3597 15.7349C18.3249 15.7697 18.2972 15.8111 18.2783 15.8566C18.2595 15.9021 18.2497 15.9509 18.2497 16.0002C18.2497 16.0495 18.2595 16.0983 18.2783 16.1438C18.2972 16.1893 18.3249 16.2307 18.3597 16.2655ZM14.6097 15.7349L18.3597 11.9849C18.4301 11.9145 18.5255 11.875 18.625 11.875C18.7245 11.875 18.82 11.9145 18.8903 11.9849C18.9607 12.0553 19.0002 12.1507 19.0002 12.2502C19.0002 12.3497 18.9607 12.4452 18.8903 12.5155L15.4052 16.0002L18.8903 19.4849C18.9607 19.5553 19.0002 19.6507 19.0002 19.7502C19.0002 19.8497 18.9607 19.9452 18.8903 20.0155C18.82 20.0859 18.7245 20.1254 18.625 20.1254C18.5255 20.1254 18.4301 20.0859 18.3597 20.0155L14.6097 16.2655C14.5749 16.2307 14.5472 16.1893 14.5283 16.1438C14.5095 16.0983 14.4997 16.0495 14.4997 16.0002C14.4997 15.9509 14.5095 15.9021 14.5283 15.8566C14.5472 15.8111 14.5749 15.7697 14.6097 15.7349Z",
    fill: "#153E4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1242_16044",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1242_16044"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1242_16044",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDrawer);
export default __webpack_public_path__ + "static/media/close-drawer.434f3a78cb1d55f37e63f075df540e5f.svg";
export { ForwardRef as ReactComponent };